import { GA4React } from "ga-4-react";

const ga4react = new GA4React("UA-153387350-1").initialize();

export interface AnalyticsData {
  title: string;
  action: string;
}

const trackPathForAnalytics = (data: AnalyticsData) => {
  const { title, action } = data;
  const mode = process.env.NODE_ENV;
  ga4react
    .then((ga) => {
      ga.event(action, title, mode);
      console.log("Event generated");
    })
    .catch((err) => console.error(`Analytics failed: ${err}`));
};

export default trackPathForAnalytics;
